import { GetServerSideProps, NextPage } from "next";

import NoAuthWrapper from "src/components/no-authentication";
import { SignUpAccountType } from "src/components/routes/SignUp/SignUp";
import { countryCodeFromRequestHeaders } from "src/common/api/utils";
import { CountryCodeSupported } from "src/common/country";
import { OptimisedSignup } from "src/components/routes/SignUp/optimised-signup/OptimisedSignup";
import { useRouterQuery } from "src/common/routing";
import { allowedFsbMemberDiscounts } from "src/utils/allowedFsbMemberDiscounts";

interface InitialProps {
  userCountry: CountryCodeSupported;
}

const SignUpRoot: NextPage<InitialProps> = ({ userCountry }) => {
  const { item: referralCode } = useRouterQuery("referral_code");
  const { item: fsbMemberDiscount } = useRouterQuery("fsb_member_discount");
  const isReferralPage = !!referralCode;
  const hasFsbMemberDiscount = allowedFsbMemberDiscounts(fsbMemberDiscount);

  return (
    <NoAuthWrapper ignoreAccessToken={isReferralPage} userCountry={userCountry}>
      <OptimisedSignup
        defaultCountryCode={userCountry}
        accountType={SignUpAccountType.SELF_SERVED}
        hasFsbMemberDiscount={hasFsbMemberDiscount}
      />
    </NoAuthWrapper>
  );
};

export const getServerSideProps: GetServerSideProps<InitialProps> = async ({
  req,
}) => {
  const userCountry = countryCodeFromRequestHeaders(
    req.headers
  ) as CountryCodeSupported;

  return {
    props: {
      userCountry,
    },
  };
};

export default SignUpRoot;
